import axios from "axios";
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import LoadingIndicator from "./LoadingIndicator";
import Illustration from "../components/Illustrations/Collaboration_1";

const AnnouncementModal = (props) => {
  const [submitting, setSubmitting] = useState(false);
  const [pageNum, setPageNum] = useState(0);

  const page = props.pages[pageNum];
  const onFinalPage = pageNum === props.pages.length - 1;
  const onFirstPage = pageNum === 0;
  const showBackButton = !onFirstPage;

  const handleSubmit = () => {
    if (!submitting) {
      setSubmitting(true);

      axios
        .post(
          props.confirmPath,
          {},
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "X-CSRF-Token": document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content"),
            },
          }
        )
        .then(() => {
          props.handleClose();
        })
        .catch((error) => {
          props.setNotice({
            kind: "error",
            open: true,
            message: error.response.data.error,
          });
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };

  function handleClick() {
    if (onFinalPage) {
      return handleSubmit();
    }

    setPageNum((pageNum) => pageNum + 1);
  }

  function renderFooter() {
    return (
      <div className="announcement_modal__footer">
        {showBackButton && (
          <div className="button" onClick={() => setPageNum((num) => num - 1)}>
            Back
          </div>
        )}
        <div className="button button--blue flex-grow-1" onClick={handleClick}>
          {submitting && <LoadingIndicator />}
          Continue
        </div>
      </div>
    );
  }

  return createPortal(
    <div className="modal__background modal__background--no-pointer">
      <div className="announcement_modal__container animated fadeInUp">
        <div className="announcement_modal__title">{page.title}</div>
        <div className="announcement_modal__body">
          <div className="announcement_modal__body__spotlight">
            <Illustration />
          </div>
          {page.body}
        </div>
        {renderFooter()}
      </div>
    </div>,
    document.body
  );
};
export default AnnouncementModal;
